import React from 'react';
import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Flex,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import Roles from './Roles';
import Administrators from './Administrators';
import { useTranslation } from 'react-i18next';

const Rbac = () => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return (
    <Flex height="100%">
      <Tabs flex={1}>
        <TabList>
          <Tab>{t('common.label.administrators')}</Tab>
          <Tab>{t('common.label.roles')}</Tab>
        </TabList>
        <TabPanels
          display="flex"
          flex={1}
          flexDirection="column"
          borderTop={1}
          borderColor={colorStyle.divider}
        >
          <TabPanel>
            {({ isSelected }: { isSelected: boolean }) =>
              isSelected ? <Administrators /> : null
            }
          </TabPanel>
          <TabPanel>
            {({ isSelected }: { isSelected: boolean }) =>
              isSelected ? <Roles /> : null
            }
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
};
export default React.memo(Rbac);
